import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { SESSION_EXPIRED_EVENT } from "../../utils/sessionEvents";

const SessionExpiredModal = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => setShow(true);
    window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
  }, []);

  const handleClose = () => {
    if (window.opener) {
      window.opener.focus();
      window.close();
    } else {
      window.location.href = "https://app.quizrr.in";
    }
  };

  return (
    <Modal centered show={show} onHide={() => {}} backdrop="static" keyboard={false}>
      <Modal.Header>
        <h2 className="mb-0 font-weight-bold">You&apos;ve been logged out</h2>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">Your session has expired. Please close this tab and log in again to continue.</p>
      </Modal.Body>
      <Modal.Footer className="py-3">
        <button type="button" className="btn btn-primary font-weight-bold px-5 py-2" onClick={handleClose}>
          Close Tab
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionExpiredModal;
